"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ssrWindow = require("ssr-window");
var _isString = _interopRequireDefault(require("lodash/isString"));
var _dom = _interopRequireDefault(require("../dom/dom"));
// t = current time, b = start value, c = change in value, d = duration
// http://stackoverflow.com/questions/8917921/cross-browser-javascript-not-jquery-scroll-to-top-animation
Math.easeInOutQuad = (t, b, c, d) => {
  /* eslint-disable no-param-reassign, no-mixed-operators */
  t /= d / 2;
  if (t < 1) {
    return c / 2 * t * t + b;
  }
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
  /* eslint-enable no-param-reassign, no-mixed-operators */
};

/**
 * Utilities for working with animations.
 * @module AnimationUtils
 */
const AnimationUtils = {
  /**
   * Scrolls the specified element to the specified position.
   * @static
   * @function scrollTo
   * @param {String|Element} el - The selector or element to scroll to.
   * @param {Number} [position=0] - The position to scroll the element to.
   * @param {Number} [duration=400] - The time (in milliseconds) to scroll.
   * @param {String} [axis='y'] - The axis to scroll on.
   * @param {Function} [cb] - A callback function to call when the animation finishes.
   * @example
   * AnimationUtils.scrollTo(window, 0, 1000);
   * @returns {void}
   */
  scrollTo(el, position = 0, duration = 400, axis = 'y', cb = null) {
    const element = (0, _isString.default)(el) ? _dom.default.el(el) : el;
    const start = axis === 'y' ? element.scrollTop : element.scrollLeft;
    const change = position - start;
    const increment = 20;
    let currentTime = 0;
    const animateScroll = () => {
      currentTime += increment;
      const val = Math.easeInOutQuad(currentTime, start, change, duration);
      if (axis === 'y') {
        element.scrollTop = val;
      } else {
        element.scrollLeft = val;
      }
      if (currentTime < duration) {
        _ssrWindow.window.setTimeout(animateScroll, increment);
      } else {
        if (cb) {
          cb();
        }
      }
    };
    animateScroll();
  }
};
var _default = exports.default = AnimationUtils;